import _JSON$stringify from 'babel-runtime/core-js/json/stringify';
export var IMAGE_TYPES = ['image/png', 'image/jpeg', 'image/svg+xml'];

export var checkSaveType = function checkSaveType(type) {
  return IMAGE_TYPES.includes(type);
};

export var DEFAULT_OPTIONS = {
  dotSize: (0.5 + 2.5) / 2,
  minWidth: 0.5,
  maxWidth: 2.5,
  throttle: 16,
  minDistance: 5,
  backgroundColor: 'rgba(0,0,0,0)',
  penColor: 'black',
  velocityFilterWeight: 0.7,
  onBegin: function onBegin() {},
  onEnd: function onEnd() {}
};

export var convert2NonReactive = function convert2NonReactive(observerValue) {
  return JSON.parse(_JSON$stringify(observerValue));
};

export var TRANSPARENT_PNG = {
  src: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=',
  x: 0,
  y: 0
};